module.exports = __webpack_public_path__ + "static/img/right_bg.a14f238.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/common/right_bg.png
// module id = iu1c
// module chunks = 7